import styles from "src/components/atoms/Chip/styles.module.css";
import cx from "classnames";
import React from "react";

export enum CHIPTYPES {
  SUCCESS = "success",
  ERROR = "error",
  NEUTRAL = "neutral",
}
type Props = {
  type?: CHIPTYPES;
  text: string;
};

export const Chip: React.FC<Props> = ({ type, text }) => (
  <div
    className={cx(styles.chip, {
      [styles.success]: type === CHIPTYPES.SUCCESS,
      [styles.error]: type === CHIPTYPES.ERROR,
    })}
  >
    {text}
  </div>
);
